import { AxiosResponse } from 'axios'
import { Moment } from 'moment'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
import { RequestREAD } from 'services/Instances'

export const WorkingDocumentationService = () => {
  const path = 'DocumentacaoTrabalhista'

  const getPaginated = async (
    request: IWorkingDocumentationRequest
  ): Promise<AxiosResponse<IPaginatedResponse<IWorkingDocumetationResponse>>> =>
    await RequestREAD.get(`${path}/GetAllPaginated`, { params: request })

  return {
    getPaginated
  }
}

export interface IWorkingDocumentationRequest {
  cdContrato: string | null
  nmFornecedor: string | null
  competenciaInicio: Date | Moment | null
  competenciaFim: Date | Moment | null
  cpf: string | null
  nmEfetivo: string | null
  idTipoDocumento: number
  pageNumber: number
  pageSize: number
}

export interface IWorkingDocumetationResponse {
  movDocumentoItemId: number
  contratoId: number
  cdContrato: string
  nmFornecedor: string
  competencia: string
  nmTipoDocumento: string
  statusColor: string
  dtAnexo: Date
  cdGedIdExterno: string | null
}
